
import { Box, Button, Typography } from "@mui/material";
import React, { useRef, useState, useEffect } from "react";
import ReactQuill from "react-quill";
import * as Yup from "yup";
import { useFormik } from "formik";
import Skeleton from "react-loading-skeleton";
import { doc, setDoc, getDoc, updateDoc, Timestamp } from "firebase/firestore";
import "react-quill/dist/quill.snow.css";
import { DATABASE } from "../../../Config/firebase";
import { toast } from "react-toastify";

const AboutUs = () => {
  const ref = useRef();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    fetchAboutUs();
  }, []);
  const fetchAboutUs = async () => {
    try {
      setIsLoading(true);
      const docRef = doc(DATABASE, "app_setting", "about-1661896397989");
      const docSnap = await getDoc(docRef);
      if (docSnap?.exists()) {
        setData(docSnap?.data().answer);
      } else {
        console.log("No such document!");
      }
    } catch (error) {
      console.error("Error fetching about : ", error);
    } finally {
      setIsLoading(false);
    }
  };
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      about: data || "",
    },
    validationSchema: Yup.object({
      about: Yup.string().required("about is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      setIsUpdating(true);
      try {
        const docRef = doc(DATABASE, "app_setting", "about-1661896397989");

        if (data) {
          await updateDoc(docRef, {
            answer: values?.about,
            doc_id:"about",
            type:1,
            update_date:Timestamp.now(),
          });
          toast.success("About Us Updated Successfully");
        } else {
          await setDoc(docRef, {
            answer: values?.about,
            doc_id:"about",
            type:1,
            created_date:Timestamp.now(),
          });
          toast.success("About Us Saved Successfully");
        }
        resetForm();
      } catch (error) {
        console.error("Error saving About Us : ", error);
      } finally {
        setIsUpdating(false);
        fetchAboutUs();
      }
    },
  });

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "16px",
          }}
        >
          <Typography sx={{ fontSize: "24px", fontWeight: "600", color: "#fff" }}>
            About Us
          </Typography>
        </Box>

        <form
          onSubmit={(e) => {
            e.preventDefault();
            formik.handleSubmit();
            return false;
          }}
          style={{
            position: "relative",
            backgroundColor: "#1e1e2e",
            padding: "15px",
            boxShadow: "0px 0px 16px rgba(0,0,0,0.4)",
            borderRadius: "10px",
            border: "1px solid rgba(255,255,255,0.1)",
          }}
        >
          <style>{`
            .aboutUsContent .ql-toolbar { background: #2a2a3e; border-color: rgba(255,255,255,0.15) !important; border-radius: 8px 8px 0 0; }
            .aboutUsContent .ql-toolbar .ql-stroke { stroke: rgba(255,255,255,0.7); }
            .aboutUsContent .ql-toolbar .ql-fill { fill: rgba(255,255,255,0.7); }
            .aboutUsContent .ql-toolbar .ql-picker { color: rgba(255,255,255,0.7); }
            .aboutUsContent .ql-toolbar .ql-picker-options { background: #2a2a3e; border-color: rgba(255,255,255,0.15); }
            .aboutUsContent .ql-toolbar button:hover .ql-stroke, .aboutUsContent .ql-toolbar button.ql-active .ql-stroke { stroke: #2af598; }
            .aboutUsContent .ql-toolbar button:hover .ql-fill, .aboutUsContent .ql-toolbar button.ql-active .ql-fill { fill: #2af598; }
            .aboutUsContent .ql-container { background: #161625; border-color: rgba(255,255,255,0.1) !important; border-radius: 0 0 8px 8px; min-height: 280px; }
            .aboutUsContent .ql-editor { color: rgba(255,255,255,0.9); font-size: 15px; min-height: 260px; }
            .aboutUsContent .ql-editor.ql-blank::before { color: rgba(255,255,255,0.35); font-style: italic; }
          `}</style>
          {isLoading ? (
            <Skeleton width={"100%"} height={"230px"} />
          ) : (
            <ReactQuill
              placeholder="Description"
              value={formik?.values?.about}
              ref={ref}
              modules={{
                toolbar: [
                  [{ header: [1, 2, 3, 4, 5, 6, false] }],
                  ["bold", "italic", "underline"],
                  [{ list: "ordered" }, { list: "bullet" }],
                  [
                    { align: "right" },
                    { align: "center" },
                    { align: null },
                    { align: "justify" },
                  ],
                ],
              }}
              onChange={(content) => {
                content = content.replace(/(^<[^>]*>)([\s]*)/gm, "$1");
                formik.setFieldValue("about", content);
              }}
              className="aboutUsContent"
            />
          )}

          <Box
            sx={{
              display: "flex",
              alignItems: "flex-end",
              justifyContent: "flex-end",
              marginTop: "24px",
            }}
          >
            <Button
              type="submit"
              variant="contained"
              disabled={
                !formik?.values?.about
                  ?.replace(/<[^>]+>/g, "")
                  .trim() || isUpdating
              }
              sx={{
                width: "120px",
                height: "44px",
                fontSize: "16px",
                fontWeight: 700,
                bgcolor: "#2af598",
                color: "#000",
                "&:hover": { bgcolor: "#1de585" },
                "&.Mui-disabled": { bgcolor: "rgba(42,245,152,0.25)", color: "rgba(0,0,0,0.5)" },
                borderRadius: "10px",
              }}
            >
              {isUpdating ? "Saving..." : "Save"}
            </Button>
          </Box>
        </form>
      </Box>
    </>
  );
};

export default AboutUs;
